export default __webpack_public_path__ + "static/media/Investment-Background.4b143f68.png";